export const VertebraSelectionModality = {
  CUSTOM_MEASUREMENT: "customMeasurement",
  OSTEOTOMY: "osteotomy",
  SEGMENTAL_TRANSFORMATION: "segmentalTransformation",
  CAGE: "cage",
};

export const SelectionNature = {
  VERTEBRAE: "Vertebrae",
  IVDS: "Intervertebral Discs",
  PEDICLES: "Pedicles",
};
